import { render, staticRenderFns } from "./Comunas.vue?vue&type=template&id=1a208318&"
import script from "./Comunas.vue?vue&type=script&lang=js&"
export * from "./Comunas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports